<template>
    <div>
        <label id="add-shop-email">
            <span class="c6 mb-2 d-block text-left">Email</span>
            <div class="input-holder d-flex">
                <input type="text" placeholder="Your email" class="w-100" v-model.trim="email" :disabled="loading">  
                <span>@{{hostname}}</span>
            </div>
        </label>
        <button class="activation-btn" @click="sendEmail" :disabled="loading || !email">
            Verify your email
        </button>
    </div>
</template>

<script>
import {ref, computed} from '@vue/composition-api'
import {message} from 'ant-design-vue'


export default {
    name: 'SendEmail',
    props: {
        domainEmail: String,
        hostname: String,
    },
    setup(props, {emit}){

        const email = ref(props.domainEmail || '')
        const loading = ref(false)

        const sendEmail = () => {
            if(!email.value){
                return message.error('Email is required')
            }
            loading.value = ref(true)
            emit('setEmail', email.value + '@' + props.hostname)
            emit('sendEmail')
        }

        return {
            email,
            loading,
            sendEmail
        }

    }
}
</script>


<style lang="scss" scoped>
#add-shop-email {
    width: 100%;
    margin-top: 95px;
}

.input-holder {
    border: 1px solid #CBD5E0;
    width: 100%;
    border-radius: 4px;

    &:focus {
        border: 1px solid #CBD5E0;
    }

    input {
        padding: 18px;
        border: none;
        border-radius: 4px;
    }

    span {
        padding: 18px;
        background: #F4F7FA;
        border-left: 1px solid #CBD5E0;
    }
}

.activation-btn {
    margin-top: 24px;
    padding: 8px 20px;
    background: #0ACF97 !important;
    border-radius: 5px;
    color: #FFFFFF;
    transition: all 0.1s linear;

    &:hover {
        box-shadow: 0px 4px 10px rgba(10, 207, 151, 0.39);
        border: 0 !important;
        outline: 0 !important;
    }

    &:disabled {
        opacity: 0.4
    }
}
</style>